import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet-async";
import { config } from '../config/env';
import HeroSection from "../components/herosection/HeroSection";
import Layout from "../components/layout/Layout";
import SearchFilterBar from "../components/searchFilter/SearchFilter";
import UniformCardGrid from "../components/uniformCard/UniformCard";
import EmptyContent from "../components/emptycontent/EmptyContent";

const Blog = () => {
  const [blogs, setBlogs] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [filterTopics, setFilterTopics] = useState("");

  const fetchBlogs = async () => {
    try {
      const query = new URLSearchParams();
      if (searchTerm) query.append("search", searchTerm);
      if (filterTopics) query.append("topic_id", filterTopics);

      query.append("limit", 6)
      query.append("sort_by", "published_at")
      query.append("order_by", "desc")
      query.append("sas_token_for_first", 6)

      const response = await fetch(
        `${config.apiBaseUrl}/api/v1/content/blogs/?${query.toString()}`,
        {
          method: "GET",
          headers: { "Content-Type": "application/json" },
        }
      );

      const data = await response.json();
      const allBlogs = data.data || [];

      const sortedBlogs = [...allBlogs].sort(
        (a, b) => new Date(b.created_at) - new Date(a.created_at)
      );

      const formatted = sortedBlogs.map((blog) => ({
        id: blog.id,
        title: blog.title || "Untitled",
        description: blog.description || "No description available.",
        preview_image_url: blog.preview_image_url || "https://via.placeholder.com/300",
      }));

      setBlogs(formatted);
    } catch (error) {
      console.error("Error fetching blogs:", error);
    }
  };

  useEffect(() => {
    fetchBlogs();
  }, [searchTerm, filterTopics]);

  const handleSectionButton = (id) => {
    window.location.href = `/blog/${id}`;
  };

  return (
    <div>
      <Helmet>
        <title>Avanade Research</title>
      </Helmet>
      <Layout>
        <div className=" px-10">
        <SearchFilterBar
          onSearchChange={setSearchTerm}
          onFilterChange={setFilterTopics}
        />
        {blogs.length > 0 ? (
          <UniformCardGrid items={blogs} showButton={true} onClicked={handleSectionButton} />
        ) : (
          <EmptyContent />
        )}
        </div>
      </Layout>
      
    </div>
  );
};

export default Blog;
